import React from 'react';
import PropTypes from 'prop-types';
import './ManagedPopup.css';
import ManagedSvg from '../project.svg';
import { Button } from '../../Button';

export const ManagedPopup = ({
  handleTalkToRepresentative,
  handleContinueFilling,
}) => (
  <div className="managed-content">
    <div className="managed-content__image-container">
      <img
        alt="Managed"
        className="managed-content__image-container__image"
        src={ManagedSvg}
      />
    </div>
    <div className="managed-content__body">
      <div className="managed-content__body__title">
        Great selections! You&apos;re nearly there,
        <br />
        but let&apos;s check in with you
      </div>
      <div className="managed-content__body__description">
        We know providing details can sometimes be a drag. However, if you
        <br />
        want to choose your creator it&apos;s helpful they have a few more
        details.
        <br />
        <br />
        Tired of answering questions? Skip the rest and let us manage the
        <br />
        project for you.
      </div>
    </div>
    <div className="managed-content__action">
      <Button
        id="managed-represent-button"
        className="managed-content__action--contact"
        onClick={handleTalkToRepresentative}
        rounded
        block
        title="fast-track me!"
      />
      <Button
        id="managed-continue-button"
        textClassName="managed-content__action--continue"
        onClick={handleContinueFilling}
        transparent
        block
        withoutTextTransform
        title="Continue filing our brief"
      />
    </div>
  </div>
);

ManagedPopup.propTypes = {
  handleTalkToRepresentative: PropTypes.func,
  handleContinueFilling: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Popup/ManagedPopup/ManagedPopup.js